import React, { useState } from 'react';
import { Modal } from '@components/utils/Modal';
import { dashboardGroupService } from '@/services/dashboardGroupService';

interface DeleteDashboardGroupModalProps {
  dashboardGroupId: number;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onUpdateDashboardGroupPosition: (removedDashboardGroupId: number) => void;
}

export const DeleteDashboardGroupModal: React.FC<any> = ({
  dashboardGroupId,
  open,
  setOpen,
  onUpdateDashboardGroupPosition,
}: DeleteDashboardGroupModalProps) =>
{
  const [loading, setLoading] = useState(false);

  const deleteDashboardGroupColumn = async (): Promise<void> =>
  {
    if (loading) return;
    setLoading(true);

    await dashboardGroupService.deleteDashboardGroup(dashboardGroupId, '');

    onUpdateDashboardGroupPosition(dashboardGroupId);
    setOpen(false);
    setLoading(false);
  };

  return (
    <Modal
      open={open}
      onClose={() =>
      {
        setOpen(false);
        setLoading(false);
      }}
      title="Delete Column"
    >
      <div>
        <p className="pt-[10px] pb-[8px] px-[20px] text-sm">
          Are you sure you want to delete this column? This action cannot be undone.
        </p>
        <div className="pt-3 text-right gap-[10px] relative overflow-hidden min-h-6 flex flex-row-reverse">
          <button
            type="button"
            disabled={loading}
            onClick={() =>
            {
              deleteDashboardGroupColumn();
            }}
            className="bg-corgee-blue hover:bg-corgee-BlueHover border text-white text-xs h-7 px-3 py-1"
          >
            Yes
          </button>
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="bg-brightGray hover:bg-corgee-brightGrayHover border text-white text-xs h-7 px-3 py-1"
          >
            No
          </button>
        </div>
      </div>
    </Modal>
  );
};
